import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon, ZapIcon } from 'lucide-react';
import { purchaseNotices } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 6000;
const GAP_MS = 12000;
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    let hideTimer: number;
    const showTimer = window.setTimeout(() => {
      setIsVisible(true);
      hideTimer = window.setTimeout(() => setIsVisible(false), VISIBLE_MS);
    }, index === 0 ? FIRST_DELAY : GAP_MS - VISIBLE_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [index, isDismissed]);
  const notice = purchaseNotices[index % purchaseNotices.length];
  return <AnimatePresence onExitComplete={() => {
    if (!isDismissed) setIndex(current => current + 1);
  }} data-id="element-160" data-mp="b3k8zyu4vfuw">
      {isVisible && !isDismissed && <motion.aside key={index} role="status" aria-live="polite" initial={{
      opacity: 0,
      y: 16,
      scale: 0.98
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.98
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 left-4 z-50 w-[min(340px,calc(100vw-2rem))] rounded-lg border-2 border-orange-500 bg-slate-950 p-3 shadow-2xl" data-id="element-161" data-mp="1z4j97eqsv7ej">
          <div className="flex items-start gap-3" data-id="element-162" data-mp="1kg6bac85jehe">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-orange-500" aria-hidden="true" data-id="element-163" data-mp="1kfddi0r67zbe">
              <ZapIcon className="h-4 w-4 fill-slate-950 text-slate-950" data-id="element-164" data-mp="rqzf3jw670zb" />
            </span>

            <div className="min-w-0 flex-1" data-id="element-165" data-mp="wq27a3r1xcpv">
              <p className="pr-5 text-[0.95rem] font-extrabold leading-tight text-white" data-id="element-166" data-mp="wp0u9tqh6g5i">
                {notice.name} — {notice.city}
              </p>
              <p className="mt-1 text-[0.9rem] font-bold leading-tight text-orange-500" data-id="element-167" data-mp="1v1vchl58lwzi">
                Just purchased ANATOMY READY™
              </p>
              <p className="mt-1 text-[0.75rem] font-bold uppercase tracking-wide text-white/85" data-id="element-168" data-mp="28w5sne364ity">
                {notice.minutesAgo} minutes ago
              </p>
            </div>
          </div>

          <button type="button" onClick={() => setIsDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded text-white/70 transition-colors duration-150 ease-out hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500" data-id="element-169" data-mp="1h4zzjhlv7le6">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-170" data-mp="2wkf9e1liyge8" />
          </button>
        </motion.aside>}
    </AnimatePresence>;
}